export default __webpack_public_path__ + "static/media/solarflare.62f60232.png";